import createIcon from '../../createIcon';

/**
 * @component @name Crop54
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEg1QzMuOSA0IDMgNC45IDMgNlYxOEMzIDE5LjEgMy45IDIwIDUgMjBIMTlDMjAuMSAyMCAyMSAxOS4xIDIxIDE4VjZDMjEgNC45IDIwLjEgNCAxOSA0Wk0xOSAxOEg1VjZIMTlWMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Crop54 = createIcon('Crop54', [
  [
    'path',
    {
      d: 'M19 4H5C3.9 4 3 4.9 3 6V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM19 18H5V6H19V18Z',
      key: 'ntp0nx',
    },
  ],
]);

export default Crop54;
